const unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/
export function applyReactStyle(element, styles) {
  if (!element || !styles) {
    return
  }
  const style = element.style

  for (const key in styles) {
    const value = styles[key]
    if (Number.isFinite(value) && !unitlessNumber.test(key)) {
      style[key] = `${value}px`
    } else {
      style[key] = value
    }
  }
}

/**
 * List of functions and their purpose:
 *
 * - applyReactStyle: Applies a set of React-style CSS properties to a DOM element, converting numeric values to pixel units where necessary.
 */
